// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__mJbPT","approved":"Status_approved__H2gPi","rejected":"Status_rejected__2wCsr","expired":"Status_expired__fF_I2","label":"Status_label__1yObj"};